import { Heading_default } from "./chunk-JL63HSDD.js";
import { Icon_default } from "./chunk-LGLZBQWG.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Empty/Empty.tsx
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var Empty = _a => {
  var _b = _a,
    {
      action,
      icon = "search",
      title,
      description,
      className
    } = _b,
    rest = __objRest(_b, ["action", "icon", "title", "description", "className"]);
  return /* @__PURE__ */jsxs("div", __spreadProps(__spreadValues({
    className: clsx("pd-empty", className)
  }, rest), {
    children: [/* @__PURE__ */jsx("figure", {
      className: "pd-rounded-sm pd-bg-white",
      children: /* @__PURE__ */jsx(Icon_default, {
        icon,
        size: "2xl",
        className: "pd-text-dim-500"
      })
    }), /* @__PURE__ */jsxs("div", {
      className: "pd-flex pd-max-w-3xl pd-flex-col pd-items-center pd-gap-1",
      children: [/* @__PURE__ */jsx(Heading_default, {
        as: "h4",
        variant: "display",
        size: "2",
        className: "",
        children: title
      }), /* @__PURE__ */jsx("div", {
        className: "",
        children: description
      })]
    }), action && /* @__PURE__ */jsx("div", {
      className: "pd-flex pd-items-center pd-gap-3",
      children: action
    })]
  }));
};
var Empty_default = Empty;
export { Empty_default };